// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"177":"73c2f014","206":"8ab5f061","241":"a82c9ec3","541":"643ba6af","936":"331948a7"}[chunkId] + ".chunk.css";
};